import { Flag, HeartHandshake, Compass, FileCheck } from "lucide-react";
import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";

const POINTS = [
  {
    icon: HeartHandshake,
    title: "Human enough to send",
    text: "Written the way a thoughtful manager would actually phrase it — not how a policy document reads.",
  },
  {
    icon: Compass,
    title: "Clear enough to manage with",
    text: "Direct without being cold. Every message says the thing that needs saying.",
  },
  {
    icon: FileCheck,
    title: "Careful with the facts",
    text: "Careful not to invent facts you haven't established. Bracketed details keep you honest.",
  },
];

export function Trust() {
  return (
    <section id="trust" className="border-y border-line bg-surface/60 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading
          index="06"
          eyebrow="Editorial standard"
          title={
            <>
              Not HR-speak. <em className="font-normal">Not corporate scripts.</em>
            </>
          }
        />
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-smoke sm:text-lg">
            SayIt is written for the way real managers actually communicate.
          </p>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={0.1 + i * 0.08} className="h-full">
              <div className="h-full rounded-xl border border-line bg-paper p-7">
                <p.icon className="h-5 w-5 text-brand" strokeWidth={1.75} />
                <p className="mt-5 font-medium text-ink">{p.title}</p>
                <p className="mt-2 text-sm leading-relaxed text-smoke">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mt-8 flex items-start gap-3 rounded-xl border border-dashed border-[#C8C7C1] bg-paper p-6">
            <Flag className="mt-0.5 h-4 w-4 shrink-0 text-smoke" />
            <p className="text-sm leading-relaxed text-smoke">
              Sensitive HR/legal situations are clearly flagged for local HR,
              policy or legal review.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
